import { render, staticRenderFns } from "./issuance.vue?vue&type=template&id=53e5f827&scoped=true&"
import script from "./issuance.vue?vue&type=script&lang=js&"
export * from "./issuance.vue?vue&type=script&lang=js&"
import style0 from "./issuance.vue?vue&type=style&index=0&id=53e5f827&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5f827",
  null
  
)

export default component.exports